<template>
  <div class="virtual-card" :style="borderTop">
    <div class="card-container">
        <div class="card-file" v-show="isDetails">
          <span>{{ cardTitle }}</span>
          <div class="card-file-svg">
            <svg-icon :name="'valid-virtual-card'" :width="200" :height="150"></svg-icon>
          </div>
        </div>

        <div class="card-button" :style="{ marginLeft: isDetails ? 'unset' : 'auto' }">
          <maf-button class="dynamic-content" :name="btnName" :width="btnWidth" @actionFunc="viewCardDetail" :bgColor="btnColor"/>
        </div>
    </div>

    <div v-show="alerting">
      <div class="maf-mask open" style=""></div>
      <div class="maf-alert open" style="">
        <div class="close-popup" @click="clearPopup()" tabindex="0" @keydown.enter.space.stop="clearPopup()" style="outline: none; cursor: pointer;">
          <svg-icon :name="'closed-popup'" :width="15" :height="15"></svg-icon>
        </div>
        <p class="title" style="padding-top: 20px;">{{ msg }}</p>
        <p class="content" v-html="content"></p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import MafButton from './MafButton.vue';

export default {
  components: { MafButton },
  props: {
    isDetails: false,
    loanIndex: Number,
    loanId: String,
  },
  data() {
    return {
      alerting: false,
      msg: '',
      content: '',
    }
  },
  watch: {
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
      isMobile: state => state.isMobile,
    }),
    borderTop() {
      if (this.isDetails) {
        return 'border-top: 2px solid #ccc;';
      } else {
        return 'border-top: unset;';
      }
    },
    btnName() {
      return 'Get virtual card';
    },
    btnColor() {
      return '-webkit-linear-gradient(left top, rgb(255, 121, 14), rgb(255, 88, 88))';
    },
    btnWidth() {
      if (this.isDetails) {
        return 250;
      } else {
        return 159;
      }
    },
    btnWidthVertically() {
      return 260;
    },
    cardTitle() {
      return 'This card has been issued for use in your USCIS application only. It will only be viewable for 60 days from the time it was issued.';
    },
  },
  methods: {
    viewCardDetail() {
      this.alerting = true;
      this.msg = 'Make an appointment';
      this.content = `<span>To get your credit card information, please use <a href="https://forms.missionassetfund.org/t/5LJd68PrxRus">this link</a> to schedule a call with us</span>`;
      this.$trackEvent('View virtual card clicked', this.userInfo);
    },
    clearPopup() {
      this.alerting = false;
      this.msg = '';
      this.content = '';
    },
  },
  mounted() {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import './../../sass/main.scss';
.card-container {
  display: flex;
  flex-direction: column;
  margin-top: 20px;
}

.card-file {
  display: flex;
  flex-direction: column;
  color: rgb(135, 135, 135);
  font-size: 16px;
}

.card-file-svg {
  width: 250px;
  text-align: center;
}

.maf-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.51;
  background: #44546a;
  display: none;
}

.maf-mask.open {
  display: block;
}

.maf-alert {
  display: none;
  position: fixed;
  top: 50%;
  transform: translate(-50%, -50%);
  left: 50%;
  width: 420px;
  padding: 30px;
  background: #fefefe;
  box-shadow: 0 2px 10px 0 rgba(138, 138, 138, 0.5);
  border-radius: 7px;
  text-align: center;
  margin-top: 50px;

  .close-popup {
    position: absolute;
    top: 20px;
    right: 20px;

    @media screen and (max-width: $max-width-phone) {
      top: 10px;
      right: 10px;
    }
  }
}

.maf-alert.open {
  display: block;
  min-width: 420px;
  max-height: 550px;
  // overflow: scroll;
}

.maf-alert.maf-actions{
  display: block;
}

.maf-alert .title {
  font-family: San Francisco Weight;
  font-size: 20px;
  color: #834bc4;
  letter-spacing: 0.21px;
  text-align: center;
}

.maf-alert .content {
  margin: 20px 20px;
  font-size: 16px;
  color: #393c40;
  letter-spacing: 0;
  text-align: center;
  line-height: 23px;
}

.maf-alert .maf-button.purple ~ .maf-button {
  margin-left: 50px;
}

.main .title {
  text-transform: unset;
}

.maf-button {
  color: #fff;
  border: none;
  border-radius: 100px;
  font-size: 16px;
  padding: 9px 10px;
  min-width: 150px;
  background-repeat: no-repeat;
  outline: none;
  text-decoration: none;
  display: inline-block;
  cursor: pointer;
  text-align: center;
  line-height: 20px;
}

.maf-button.purple {
  background-image: linear-gradient(134deg, #3023AE 0%, #C86DD7 100%);
}

.maf-alert .maf-button.purple ~ .maf-button {
  margin-left: 50px;
}

.tip-icon {
  position: relative;
  display: inline-block;
  text-align: center;
  background-color: #834bc4;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  font-size: 15px;
  line-height: 22px;
  margin-left: 10px;
  cursor: pointer;
  font-family: San Francisco !important;
}

.tip-icon:before {
  content: 'i';
  color: #fff;
}

.tip-icon:hover p {
  display: block;
  transform-origin: 100% 0%;
  -webkit-animation: fadeIn 0.3s ease-in-out;
  animation: fadeIn 0.3s ease-in-out;
}

.tip-icon p {
  display: none;
  text-align: left;
  background-color: #6b40be;
  padding: 16px;
  width: 200px;
  position: absolute;
  border-radius: 5px;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);
  bottom: 32px;
  color: #fff;
  font-size: 0.9rem;
  line-height: 1.4;
  z-index: 1000;
  cursor: default;
  right: -192px;
}

.tip-icon p:before {
  position: absolute;
  content: '';
  width: 0;
  height: 0;
  border: 12px solid transparent;
  border-top-color: #6446b7;
  left: -12px;
  bottom: -8px;
  transform: rotate(135deg);
}

@media screen and (max-width: 768px), screen and (max-width: 950px) and (max-height: 500px) {
  .maf-alert {
    padding: 20px;
    width: calc(100% - 80px);
  }

  .maf-alert.open {
    min-width: unset;
  }

  .maf-alert .maf-button {
    width: 80%;
  }

  .maf-alert .maf-button.purple ~ .maf-button {
    margin-top: 10px;
    margin-left: 0;
  }

  .maf-alert .maf-button {
    width: 80%;
  }

  .maf-alert .maf-button.purple ~ .maf-button {
    margin-top: 10px;
    margin-left: 0;
  }

  .maf-alert.maf-actions{
    flex-direction: column;
  }

  .maf-btn {
    width: 100% !important;
  }

  .card-button {
    margin-left: unset !important;
  }

  .card-file-svg {
    width: unset;
  }

  .tip-icon p {
    right: 10px;
    width: calc(100vw - 270px);
  }

  .tip-icon p:before {
    left: auto;
    right: 0px;
    bottom: -8px;
    transform: rotate(90deg);
  }
}

@media screen and (max-height: 500px) {
  .maf-alert.open {
    max-height: 270px;
    overflow: scroll;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/common/VirtualCard.vue